import styled from 'styled-components';
import Text from '../../components/BuildingBlocks/Text';

export const PropertyMapWrapper = styled.div`
  margin-top: 20px;
`;

export const ErrorText = styled(Text.HeadingFifth)`
  color: #f44336;
  margin-top: 0px;
  margin-bottom: 0px;
`;

export const Sticky = styled.div`
  width: 100%;
  left: 0;
  z-index: 3;

  &.top {
    position: absolute;
    top: 0;
  }

  &.sticking {
    position: fixed;
    bottom: 0;
  }

  &.bottom {
    position: absolute;
    /* top set by js */
  }
`;

export const StickyStart = styled.div`
  position: relative;
`;

export const StickyEnd = styled.div`
  height: 0;
`;

export const InfoContainer = styled.div`
  padding: 2rem;
  background-color: #f6f5f6;
`;
